import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import * as constants from '../common/constants';
import * as JspUtil from '../common/JspUtil';
import * as globalActions from '../layout/actionCreators';
import LoginTemplate from '../loginpages/LoginTemplate';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { useJspVariables, useAppContext, useDebugRender, usePageTitle } from '../hooks';
import { useAuth } from '../auth';
import { IceIcon, PageContainer, PageHeader } from '../components';

const PageLogin = () => {
    useDebugRender('PageLogin');
    usePageTitle('Sign In');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { jspVariables, launcher, panelStyle } = useJspVariables();
    const { getLoginApp, getLabelFromJspVariables } = useAppContext(jspVariables);

    const { authenticatedUser } = useAuth();
    const appUiMessages = useSelector(state => state.globalReducer.appUiMessages);
    const appKey = jspVariables.jspLoginApp || getLoginApp() || '';

    const [relogin, setRelogin] = useState(false);

    const [pageMessage] = useState(() => {
        if (location.state?.pageMessage) {
            return location.state.pageMessage;
        }
        if (JspUtil.isValueAvailable(window.jspErrorMessage)) {
            return window.jspErrorMessage;
        }
        return '';
    });

    const getUiMsg = (key) => {
        if (appUiMessages) {
            let msg = null;
            appUiMessages.forEach(m => {
                if (m.uiPlaceHolder == key) {
                    msg = m.message;
                }
            });
            if (msg != null) {
                return msg;
            }
        }
        return '';
    };

    useEffect(() => {
        if (appKey) {
            dispatch(globalActions.getAppUiMessages(appKey));
        } else if (getLoginApp() && getLoginApp() !== 'LAUNCHER') {
            dispatch(globalActions.getAppUiMessages(getLoginApp()));
        } else if (getLoginApp() && getLoginApp() === 'LAUNCHER') {
            dispatch(globalActions.getAppUiMessages(getLoginApp()));
        }

        if (authenticatedUser && authenticatedUser.user) {
            navigate(constants.ROUTE_PAGE_AUTHENTICATED);
            return;
        }

        if (JspUtil.isValueAvailable(window.jspReloginUserId)) {
            setRelogin(true);
        }

    }, []);

    const loginHelp = getUiMsg(constants.LOGIN_HELP);
    const loginHeader = getUiMsg(constants.LOGIN_APP_HEADER);

    return (
        <PageContainer id="pageLogin" dataAutomationId="page_login">
            <Box style={panelStyle}>
                <IceIcon launcher={launcher} />
                {relogin ?
                    <PageHeader dataAutomationId="login_header">{getLabelFromJspVariables('title_reauthenticate')}</PageHeader>
                    :
                    <PageHeader dataAutomationId="login_header">
                        {loginHeader ?
                            <Box dangerouslySetInnerHTML={{ __html: loginHeader }} />
                            :
                            getLabelFromJspVariables('title_sso_login')
                        }
                    </PageHeader>
                }
                {pageMessage && <Alert severity="error" sx={{ mb: 1 }}>{pageMessage}</Alert>}
                <Box>
                    <LoginTemplate />
                </Box>
                {loginHelp &&
                    <Box id="login-app-ui-message" data-automation-id="login_app_ui_message">
                        <Box dangerouslySetInnerHTML={{ __html: loginHelp }} />
                    </Box>
                }
            </Box>
        </PageContainer>
    );
};

export default PageLogin;
